import { makeStyles } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import * as React from 'react'

import Avatar from '../avatar/Avatar'
import { Card, CardActionArea, CardContent, CardActions } from '../base/Card'
import Typography from '../base/Typography'
import Button from '../button/Button'
import Icon from '../icons/Icons'

export type CardServiceProps = {
  title: string
  subtitle?: string
  disabled?: boolean
  actionButton?: React.ReactNode
  isSelected?: boolean
  onClick?(): void
  onClickAction?(): void
}

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    border: 'solid 1px',
    borderColor: theme.palette.secondary.main,
    position: 'relative',
    overflow: 'visible'
  },
  content: { padding: theme.spacing(1) },
  selectedCard: {
    backgroundColor: fade(theme.palette.secondary.main, 0.06)
  },
  fontWeight700: {
    fontWeight: 700
  },
  avatarRoot: {
    position: 'absolute',
    top: -8,
    right: -8,
    background: theme.palette.secondary.main
  }
}))
export const CardService: React.FC<CardServiceProps> = (props) => {
  const {
    title,
    subtitle,
    disabled,
    isSelected,
    actionButton,
    onClick,
    onClickAction
  } = props
  const classes = useStyles()
  return (
    <Card
      classes={{ root: classes.cardRoot }}
      className={isSelected ? classes.selectedCard : ''}
    >
      {isSelected && (
        <Avatar className={classes.avatarRoot} customSize="small">
          <Icon iconName="TickIcon" size="small" />
        </Avatar>
      )}
      <CardActionArea onClick={onClick} disabled={disabled}>
        <CardContent classes={{ root: classes.content }}>
          <Typography
            variant="subtitle1"
            color="primary"
            align="center"
            children={title}
          />
          <Typography
            bodyVariants="xsBold"
            color="secondary"
            align="center"
            children={subtitle}
          />
        </CardContent>
      </CardActionArea>
      <CardActions>
        {actionButton ?? (
          <Button
            onClick={onClickAction}
            fullWidth
            variants="ghost"
            className={classes.fontWeight700}
            disabled={disabled}
          >
            View Detail
          </Button>
        )}
      </CardActions>
    </Card>
  )
}
